import axios from 'axios';
import { getCookie } from './legacy-utilities';

export const axiosInstance = axios.create();

axiosInstance.defaults.headers.post['X-CSRFToken'] = getCookie('csrftoken');
